import { createContext } from 'react'

export { SidebarLayoutContext }

// Provided by the SidebarLayout: the elements pages render into, once they are
// mounted. Null outside the layout.
const SidebarLayoutContext = createContext<{
  breadcrumbsSlot: HTMLElement | null
  drawerSlot: HTMLElement | null
} | null>(null)
